export type PaneWidthConfig = {
  min: number
  max: number
  collapsed: number
}

export const builderPaneDefaults = {
  left: { min: 240, max: 420, collapsed: 48 },
  right: { min: 280, max: 460, collapsed: 48 },
} satisfies Record<'left' | 'right', PaneWidthConfig>

export const questionGroupPaneDefaults = {
  left: { min: 240, max: 420, collapsed: 48 },
  right: { min: 300, max: 500, collapsed: 48 },
} satisfies Record<'left' | 'right', PaneWidthConfig>

export const formSettingsPaneDefaults = {
  nav: { min: 190, max: 320, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const imageEditorPaneDefaults = {
  right: { min: 280, max: 460, collapsed: 48 },
} satisfies Record<'right', PaneWidthConfig>

export const customerDetailPaneDefaults = {
  nav: { min: 200, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const adminFormPaneDefaults = {
  nav: { min: 220, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const sharePanelPaneDefaults = {
  nav: { min: 240, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const previewPaneDefaults = {
  nav: { min: 220, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const formManagementPaneDefaults = {
  nav: { min: 240, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const salesDialogPaneDefaults = {
  nav: { min: 190, max: 320, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const sourceRecordPaneDefaults = {
  nav: { min: 220, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export const formFolderPaneDefaults = {
  nav: { min: 220, max: 360, collapsed: 48 },
} satisfies Record<'nav', PaneWidthConfig>

export function clampPaneWidth(width: number, config: PaneWidthConfig) {
  return Math.min(config.max, Math.max(config.min, Math.round(width)))
}

export function getThreePaneGridTemplate({
  leftWidth,
  rightWidth,
  leftCollapsed,
  rightCollapsed,
  centerMinWidth,
  leftConfig = builderPaneDefaults.left,
  rightConfig = builderPaneDefaults.right,
}: {
  leftWidth: number
  rightWidth: number
  leftCollapsed: boolean
  rightCollapsed: boolean
  centerMinWidth: number
  leftConfig?: PaneWidthConfig
  rightConfig?: PaneWidthConfig
}) {
  const left = leftCollapsed ? leftConfig.collapsed : clampPaneWidth(leftWidth, leftConfig)
  const right = rightCollapsed ? rightConfig.collapsed : clampPaneWidth(rightWidth, rightConfig)
  return `${left}px minmax(${formatGridMinWidth(centerMinWidth)},1fr) ${right}px`
}

export function getTwoPaneGridTemplate({
  navWidth,
  navCollapsed,
  contentMinWidth,
  navConfig = formSettingsPaneDefaults.nav,
}: {
  navWidth: number
  navCollapsed: boolean
  contentMinWidth: number
  navConfig?: PaneWidthConfig
}) {
  const nav = navCollapsed ? navConfig.collapsed : clampPaneWidth(navWidth, navConfig)
  return `${nav}px minmax(${formatGridMinWidth(contentMinWidth)},1fr)`
}

export function getRightPaneGridTemplate({
  rightWidth,
  rightCollapsed,
  contentMinWidth,
  rightConfig = imageEditorPaneDefaults.right,
}: {
  rightWidth: number
  rightCollapsed: boolean
  contentMinWidth: number
  rightConfig?: PaneWidthConfig
}) {
  const right = rightCollapsed
    ? rightConfig.collapsed
    : clampPaneWidth(rightWidth, rightConfig)
  return `minmax(${formatGridMinWidth(contentMinWidth)},1fr) ${right}px`
}

function formatGridMinWidth(width: number) {
  return width === 0 ? '0' : `${width}px`
}
